import { useGetCarbonCalculatorsListQuery } from '@api/carbon-calculators';
import { CLOSED_PHOTO_INDEX } from '@g17eco/molecules/lightbox';
import { useToggle } from '@hooks/useToggle';
import { AnalyticsEvents } from '@services/analytics/AnalyticsEvents';
import { getAnalytics } from '@services/analytics/AnalyticsService';
import { useState } from 'react';

interface LightboxState {
  slides: { src: string }[];
  index: number;
}

const DEFAULT_LIGHTBOX_STATE: LightboxState = { slides: [], index: CLOSED_PHOTO_INDEX };

interface HandleGoToLinkParams {
  link: string;
  code: string;
}

export const useEmissionsCalculator = () => {
  const [lightbox, setLightbox] = useState<LightboxState>(DEFAULT_LIGHTBOX_STATE);
  const calculatorsList = useGetCarbonCalculatorsListQuery();
  const [requestModalOpen, toggleRequestDemoModal] = useToggle(false);

  const handleGoToLink = ({ link, code }: HandleGoToLinkParams) => {
    getAnalytics().track(AnalyticsEvents.EmissionCalculatorExternalView, { code });
    window.open(link);
  };

  const handleResetLightbox = () => {
    setLightbox(DEFAULT_LIGHTBOX_STATE);
  };

  const handleSetLightBox = ({ images, index }: { images: string[]; index: number }) => {
    const slides = images.map((image) => ({
      src: image,
    }));
    setLightbox({ slides, index });
  };

  return {
    calculatorsList,
    lightbox,
    handleSetLightBox,
    handleResetLightbox,
    requestModalOpen,
    toggleRequestDemoModal,
    handleGoToLink,
  };
};
